require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-dmp-data-platform.json") })
        }
      }, "path---authors-dmp-data-platform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-dmp-data-platform!./.cache/json/authors-dmp-data-platform.json
// module id = 1275
// module chunks = 231608221292675